export default __webpack_public_path__ + "static/media/section5-pic3.1d2caa54.png";